
<div class="form-success-message-container">
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%;">
        <h2 style="margin-bottom: 1em;">THANK YOU!</h2>
        <app-success-error [success]="true"></app-success-error>
        <h3>We Received Your Form</h3>
    </div>

    <div class="timeline-container">
        <h3>What happens next?</h3>
        
        <div class="timeline-item completed">
            <div class="icon-wrapper">
                <mat-icon>check_circle</mat-icon>
            </div>
            <div class="content">
                <p class="status">Form Submitted</p>
            <p class="description">Your responses have been captured and applied to the PDF.<br/><i>This link will expire in approximately 15 minutes.</i></p>
            <a mat-button color="accent" (click)="downloadForm()">
                <mat-icon>file_download</mat-icon> Download PDF Copy
            </a>
            </div>
        </div>

        <div class="timeline-item active">
            <div class="icon-wrapper">
            <mat-icon>find_in_page</mat-icon>
            </div>
            <div class="content">
            <p class="status">Internal Review</p>
            <p class="description">Our team is verifying the property details and consultant information.</p>
            </div>
        </div>

        <div class="timeline-item pending">
            <div class="icon-wrapper">
            <mat-icon>mail</mat-icon>
            </div>
            <div class="content">
            <p class="status">Email Notification</p>
            <p class="description">Once reviewed, you'll receive a confirmation email at your registered address.</p>
            </div>
        </div>
    </div>
</div>
